


























import draggable from 'vuedraggable';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ModuleStepListStep from '@/views/ModulePage/ModuleStepListStep.vue';
import ModuleStepListStepActivator from '@/views/ModulePage/ModuleStepListStepActivator.vue';
import { Step } from '@/interfaces/Step';
import { Module } from '@/interfaces/Module';

@Component({
  components: {
    ModuleStepListStepActivator,
    ModuleStepListStep,
    draggable
  }
})
export default class ModuleStepList extends Vue {
  @Prop({ default: () => null })
  steps!: Step[];

  @Prop()
  module!: Module;

  @Prop()
  nested!: boolean;

  @Prop()
  selectedEnvironment!: number;

  @Prop()
  defaultTab!: number;

  @Prop()
  environmentSteps!: Step[];

  get listHeight() {
    const height = window.innerHeight * 0.8;
    if (height > 800) return height;
    return 800;
  }

  get dragOptions() {
    return {
      animation: 0,
      group: 'description',
      disabled: false,
      ghostClass: 'ghost'
    };
  }
}
